<template>
    <main id="hcid-wrapper">
        <div id="hcid-page" class="pb-4">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'HCID', url: app_url+'/hcid', status: true }
                ]"
            ></breadcrumb>
            <ModalQR :cardNumber="qr.cardNumber" :size="qr.size" level="H" :user="user"></ModalQR>
            <div class="container-fluid title-row">
                <div class="container py-5">
                    <div class="row">
                        <div class="col">
                            <h2 class="title">Honda Community ID</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container py-4">
                <div class="card card-info">
                    <div class="card-body">
                        <div class="row">
                            <a :href="app_url+'/hcid'" class="btn btn-black py-2 my-2">Biodata</a>
                            <div class="col my-2">
                                <hr class="divider-hr">
                            </div>
                            <a :href="app_url+'/hcid/kopdar'" class="btn btn-black py-2 my-2">Kopdar</a>
                            <div class="col my-2">
                                <hr class="divider-hr">
                            </div>
                            <a :href="app_url+'/hcid/kta'" class="btn btn-red py-2 my-2">KTA</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container my-4">
                <div class="card card-info">
                    <div class="card-body">
                        <h2 class="no-margin">FAQ</h2>
                    </div>
                </div>
            </div>
        </div>
        <section id="faq-section" class="section">
            <div class="container">
                <div class="list-faq">
                    <div id="tnc-accodion" v-if="faq && faq.length > 0">
                        <div class="items" v-for="(data, index) in faq" :key="index" :ref="'items'+index" @click="toggleAccordion('items'+index, data)">
                        <h4 class="page">{{ data.question }}</h4>
                        <div class="content" v-html="data.answer">
                        </div>
                        </div>
                    </div>
                </div>

                <div class="row_flex_black">
                    <p>Ada Pertanyaan ? Kunjungi Help Center</p>
                    <div class="right-button">
                        <div class="cta-product-box black_submit">
                            <a v-if="help_url" :href="help_url" class="tx-white">Help Center</a>
                            <a v-else href="mailto:info@hondacommunity.net" class="tx-white">Help Center</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import ModalQR from "../../widget/ModalQR";
import HcidEventCard from "../../widget/HcidEventCard";
import Games from "../../widget/Games";

export default {
    components: {
        breadcrumb: BreadCrumb,
        ModalQR,
        HcidEventCard,
        Games,
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            help_url:null,
            titleClass: {
                'sub-title-list-transaksi': true,
            },
            selectedTitle: 'earn',
            qr: {
                cardNumber: 'HCID00099777',
                size: 247,
            },
            points:[],
            loaderpoint:true,
            mobile: false,
            user:null,
            faq: [],
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.help_url = help_url;
        this.mobile = isMobile;
        this.getFaq();
    },
    methods: {
        seeMoreTracker(data) {
            const track = {
                'event': 'seeMore',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'See More Detail',
                'eventDetail.label': window.location.href,
                'list': data.question ?? '',
            }
            dataLayer.push(track);
        },
      getFaq() {
          axios
              .get(api_url+"/faq/1")
              .then(res => {
                  this.faq = res.data.data;
                //   if (res.status == 200) {
                //       if (res?.data?.status) {
                //           this.faq.push(
                //               ...res?.data?.data?.faq
                //           );
                //       }
                //   }
              })
              .catch(err => {
                  console.log(err);
              });
      },
      toggleAccordion(element, data){
        this.seeMoreTracker(data)
        let el = this.$refs[element];
        let page = el[0].children[0];
        if(page.classList.value.includes("active")){
          page.classList.remove('active');
        }else{
          page.classList.add('active');
        }
        let content = el[0].children[1];
        if(content.classList.value.includes("active")){
          content.classList.remove('active');
        }else{
          content.classList.add('active');
        }
      },
    },
    mounted() {
        $.fn.accordion_tnc = function () {
            $(".page").click(function (e) {
              console.log(e)
                if (!$(this).is('.active')) {
                    $(".page,.content").removeClass('active');
                    $(".page").siblings('.content:visible').slideUp("slow");
                    $(this).addClass('active');
                    $(this).siblings('.content').slideDown("slow");
                    $(this).siblings('.content').addClass("active");
                } else {
                    $(this).removeClass('active');
                    $(this).siblings('.content').slideUp("slow");
                }
            });
        }
        $("#tnc-accodion").accordion_tnc();
    }
};
</script>

<style scoped lang="scss">

 #tnc-accodion{
    .content.active{
      display: block;
    }
 }
 #faq-section{
     padding-bottom: 50px;
 }
#hcid-wrapper{
    background: #000000;
    .card{
        background: #282828;
        border-radius: 10px;
        color: #FFFFFF;
    }
    .title-row{
        background: #191919;
        opacity: 0.95;
    }
    .title{
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        color: #FFFFFF;
    }
    .poin-head{
        max-height: 43px;
    }
    #poin-amount{
        vertical-align: sub;
    }
    .btn-tukar{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF !important;
        flex: none;
        order: 0;
        flex-grow: 0;
        border: 1px solid #686868;
        box-sizing: border-box;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }
    .btn-view{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF;
        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 0px 10px;
        background: #E61B33;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }
    .btn:hover{
        color: #FFFFFF;
    }
    .btn-red{
        background: #E61B33;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
    }
    .btn-black{
        background: rgba(0, 0, 0, 0.6);
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
    }
    .divider-hr{
        border: 1px dashed #B4B4B4;
    }
    .card-info{
        background: #1C1C1C;;
        border-radius: 10px;
    }
    .profile-img{
        border-radius:50%;
        max-height: 99px;
    }
    .row-name{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
    }
    .row-club{
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        color: #B4B4B4;
    }
    .sub-title{
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        color: #FFFFFF;
        border-bottom: 3px solid #FFFFFF;
        display: inline-flex;
    }
    .btn-see-more{
        background: #282828;
        border-radius: 10px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
    }
    .btn-redeem{
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        flex-grow: 0;
        background: #E61B33;
        border-radius: 10px;
    }
    .sub-title-list-transaksi{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 45px;
        color: #FFFFFF;
        cursor: pointer;
        display: inline-block;
        height: 45px;
        padding: 0 20px;
    }
    .selected-list-transaction{
        border-bottom: 4px solid #E61B33;
    }
    .hr-transaksi{
        opacity: 0.2;
        border: 1px solid #FFFFFF;
        margin-top: unset;
        margin-bottom: unset;
    }
    .img-poin{
        max-height: 50px;
    }
    .poin-value{
        left: -5px;
        top: 2px;
        position: absolute;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 25px;
        text-align: center;
        color: #000000;
        z-index: 100;
        width: 40px;
        height: 40px;
        font-size: 12px;
    }
    .poin-text{
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        display: block;
    }
    .date-content{
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        color: #B4B4B4;
    }
    .title-content{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
    }
    .col-title{
        text-align-last: justify;
    }
    .title-list-transaksi{
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
        color: #FFFFFF;
        display: inline-flex;
        margin: unset;
    }
    @media (max-width: 768px) {
        .col-profile-image{
            max-width: fit-content;
        }
        .btn-view{
            margin:unset;
            display: table;
            margin-bottom: 0.5rem;
            margin-top: 0.5rem;
        }
        .title{
            padding-top: 2rem !important;
        }
        .img-card{
            max-height: 228.61px;
        }
        .name-card{
            font-size: 16px;
            line-height: 26px;
        }
        .detail-event{
            font-size: 12px;
        }
        .poin-head{
        max-height: 33px;
        }
        .col-left{
            width:auto;
        }
        .poin-value{
            left: 22px;
        }
        .sub-title{
            font-size: 16px;
            line-height: 26px;
        }
        .title-list-transaksi{
            font-size: 25px;
            line-height: 35px;
        }
        .btn-redeem{
            font-size: 12px;
            line-height: 25px;
        }
    }
}

.row_flex_black{
    display:flex;
    align-items:center;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.02);
    box-shadow: 8px 4px 25px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding:20px;
    margin:30px 0 0 0;
}
.row_flex_black p{
    font-weight: 600;
    font-size: 14px;
    color: #FFFFFF;
}
.row_flex_black .cta-product-box a{
    background:#282828;
    border:1px solid #282828;
    padding:5px 15px

}
@media all and (max-width:767px){
  .row_flex_black{
    display: block;
  }
}
</style>
